/* index.js */ function _(require, module, exports, __esModule, __esExport) {
    __esModule();
    const tslib_1 = require("tslib");
    const Panel = tslib_1.__importStar(require("b51d785f31") /* ./models */);
    exports.Panel = Panel;
    const base_1 = require("@bokehjs/base");
    base_1.register_models(Panel);
}
